import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap';

import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

import SolutionSidebar from '../elements/services/solution-sidebar';

import Banner1 from '../../images/banner/banner1.jpg';
import Banner2 from '../../images/electricpower2.jpg'
import ServicesPic1 from '../../images/electric3.jpg';
import ServicesPic2 from '../../images/services/pic2.jpg';

class SolutionElectrical extends Component {

    render() {
        return (
            <>
               <Header1 />

<div className="page-content bg-white">

    <div className="page-banner ovbl-dark parallax" style={{ backgroundImage: "url(" + Banner2 + ")" }}>
        <div className="container">
            <div className="page-banner-entry">
                <h1 className="text-white">Electrical, Power & Automation Solutions</h1>
                <div className="breadcrumb-row">
                    <ul className="list-inline">
                        <li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
                        <li>Engineering Services</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div className="content-block" id="content-area">

        <div className="section-area section-sp2">
            <div className="container about-video">

                <div className="row">

                    <div className="col-lg-4 col-md-5 m-b30">
                        <SolutionSidebar activeService={10} />
                    </div>

                    <div className="col-lg-8 col-md-7 service-textarea">

                        <div className="heading-bx text-left m-b20">
                            <h3 className="title-head m-b0">Electrical & Power Engineering Services</h3>
                            <div className="ttr-separator sepimg"></div>
                        </div>

                        <p>
                            GO-PS delivers comprehensive electrical and power engineering solutions for Oil & Gas,
                            industrial, and energy facilities, ensuring safe, reliable, and efficient power systems
                            throughout the asset lifecycle.
                        </p>

                        <div className="row m-b30">
                            <div className="col-md-12">
                                <img src={ServicesPic1} className="radius-sm imghight" alt="" />
                            </div>
                        </div>

                        <h4 className="title m-b5">Our Solutions</h4>
                        <p>
                            We support medium and low voltage infrastructure, power system studies, and backup
                            energy solutions to guarantee operational continuity and regulatory compliance.
                        </p>

                        <div className="row">
                            <div className="col-lg-6">
                                <ul className="list-check">
                                    <li>MV / LV distribution networks</li>
                                    <li>Electrical substations & switchgear</li>
                                    <li>Transformers & protection relays</li>
                                </ul>
                            </div>
                            <div className="col-lg-6">
                                <ul className="list-check">
                                    <li>Power system studies & arc-flash analysis</li>
                                    <li>Generators, UPS & emergency power systems</li>
                                </ul>
                            </div>
                        </div>

                        <h4 className="title m-b5">Benefits</h4>
                        <p>Optimized electrical performance, improved safety, and reduced operational risks.</p>

                        <div className="row">
                            <div className="col-xl-7 col-lg-12">
                                <ul className="service-list-circle">
                                    <li><i className="flaticon-maintenance"></i>Reliable and compliant power infrastructure</li>
                                    <li><i className="flaticon-light-bolt"></i>Energy efficiency & loss reduction</li>
                                    <li><i className="flaticon-mask"></i>Enhanced system safety and resilience</li>
                                </ul>
                            </div>
                        </div>

                        <Accordion className="ttr-accordion gray" defaultActiveKey="0">

                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                    <Link to="#">Power Distribution & Substations</Link>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        Engineering, installation, and modernization of MV/LV networks,
                                        substations, transformers, and protection systems.
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>

                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                    <Link to="#">Power System Studies</Link>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body>
                                        Load flow, short-circuit, protection coordination, and arc-flash studies
                                        ensuring system safety and compliance.
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>

                        </Accordion>

                        <div className="heading-bx text-left m-t40 m-b20">
                            <h3 className="title-head m-b0">Automation, SCADA & Digital Energy</h3>
                            <div className="ttr-separator sepimg"></div>
                        </div>

                        <p>
                            GO-PS integrates advanced automation and SCADA solutions to provide real-time visibility,
                            intelligent control, and performance optimization of electrical and industrial assets.
                        </p>

                        <h4 className="title m-b5">Our Solutions</h4>

                        <div className="row">
                            <div className="col-lg-6">
                                <ul className="list-check">
                                    <li>SCADA, EMS & DMS platforms</li>
                                    <li>Substation automation (SAS / SCS)</li>
                                    <li>PLC, RTU & HMI systems</li>
                                </ul>
                            </div>
                            <div className="col-lg-6">
                                <ul className="list-check">
                                    <li>Industrial communication networks</li>
                                    <li>Integration with Oil & Gas control systems</li>
                                </ul>
                            </div>
                        </div>

                        <h4 className="title m-b5">Benefits</h4>
                        <p>Improved operational visibility, predictive maintenance, and smarter energy management.</p>

                        <Accordion className="ttr-accordion gray" defaultActiveKey="0">

                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                    <Link to="#">SCADA & Control Systems</Link>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        Centralized monitoring and control of electrical and industrial processes
                                        with secure and reliable architectures.
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>

                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                    <Link to="#">Digital Energy Solutions</Link>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body>
                                        Energy optimization, system analytics, and digital tools supporting smarter
                                        and more resilient infrastructures.
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>

                        </Accordion>

                    </div>

                </div>

            </div>
        </div>

    </div>

</div>

<Footer1 />


            </>
        );
    }
}

export default SolutionElectrical;
